import { useReducer, useEffect } from "react";
import "../Lightcast.scss";

import { sendRequest } from "../../../common/http";
import BottomGrowingOccupations from "./BottomGrowingOccupations";
import TopGrowingOccupations from "./TopGrowingOccupations";
import translate from "@/i18n/translate";
import { IndustryOrOccupation, IndustriesOrOccupations } from "../Interface";

interface OccupationsState {
  bottomGrowingOccupations: null | IndustryOrOccupation[];
  topGrowingOccupations: null | IndustryOrOccupation[];
  loader: boolean;
  apiError: boolean;
}

interface OccupationAction {
  type: string;
  data: IndustriesOrOccupations;
}

const defaultIndustriesOrOccupations = {
  top: [],
  bottom: []
};

const defaultOccupationAction = {
  type: "",
  data: defaultIndustriesOrOccupations
};

const initialState = {
  bottomGrowingOccupations: null,
  topGrowingOccupations: null,
  loader: true,
  apiError: false
};

const reducer = (state: OccupationsState, action: OccupationAction) => {
  switch (action.type) {
    case "setOccupations":
      return {
        ...state,
        bottomGrowingOccupations: action.data?.bottom,
        topGrowingOccupations: action.data?.top,
        loader: false
      };
    case "setOccupationsError":
      return {
        ...state,
        bottomGrowingOccupations: null,
        topGrowingOccupations: null,
        loader: false,
        apiError: true
      };
    default:
      return state;
  }
};

export interface OccupationsProps {
  onComponentLoad: (component: string) => void;
}

export default function Occupations({ onComponentLoad }: OccupationsProps) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const applyResult = (result: IndustriesOrOccupations) => {
      dispatch({ type: "setOccupations", data: result });
      onComponentLoad("occupations");
    };

    const onError = (error: any) => {
      dispatch({ ...defaultOccupationAction, type: "setOccupationsError" });
    };

    sendRequest(
      { uri: "/lightcast/occupations", camelize: true },
      applyResult,
      onError
    );
  }, []);
  return (
    <div className="grid-container wm-grid-col-12 wm-grid-col-lg-12 wm-grid-col-md-10 wm-grid-col-sm-8">
      <div className="industries-occupations-label -occupation">
        {translate("app.lightcast.occupationsLabel")}
      </div>
      <div className="wm-grid-row">
        <div className="grid-container wm-grid-col-6 wm-grid-col-xl-6 wm-grid-col-lg-6 wm-grid-col-md-10 wm-grid-col-sm-8 -min-width">
          <BottomGrowingOccupations
            occupations={state.bottomGrowingOccupations}
            loader={state.loader}
          />
        </div>
        <div className="grid-container wm-grid-col-6 wm-grid-col-xl-6 wm-grid-col-lg-6 wm-grid-col-md-10 wm-grid-col-sm-8 -min-width">
          <TopGrowingOccupations
            occupations={state.topGrowingOccupations}
            loader={state.loader}
          />
        </div>
      </div>
    </div>
  );
}
